/*
 * � 2025, NTT Data Group. All rights reserved. See LICENSE.txt file in the project root for third party licenses info.
 */

import { of, throwError } from "rxjs";
import { HttpRequestOptions } from "../../../../models/ui/http-request-options.model";
import { HttpParams } from "@angular/common/http";
import {
	EDIT_ALL_SCENARIO_LAYERS_RESPONSE,
	EDIT_SCENARIO_LAYER_RESPONSE
} from "./what-if-layer.db";
import { ApplicationError } from "../../../../models/ui/application-error.model";

export class WhatIfLayer {
	public static editAllScenarioLayers(options: HttpRequestOptions) {
		const { params, pathParams, body } = options;

		const httpParams = params as HttpParams;

		if (!httpParams)
			return throwError(
				() =>
					new ApplicationError(
						"No params provided",
						this.constructor.name,
						this.editAllScenarioLayers.name
					)
			);

		const tenantId = httpParams.get("tenantId");

		if (!tenantId)
			return throwError(
				() =>
					new ApplicationError(
						"No tenant token provided",
						this.constructor.name,
						this.editAllScenarioLayers.name
					)
			);

		const appId = pathParams?.["appId"];
		const scenarioId = pathParams?.["scenarioId"];

		if (!appId || !scenarioId)
			return throwError(
				() =>
					new ApplicationError(
						"Missing required parameters",
						this.constructor.name,
						this.editAllScenarioLayers.name
					)
			);

		if (!body)
			return throwError(
				() =>
					new ApplicationError(
						"No body provided",
						this.constructor.name,
						this.editAllScenarioLayers.name
					)
			);

		return of(EDIT_ALL_SCENARIO_LAYERS_RESPONSE);
	}

	public static editScenarioLayer(options: HttpRequestOptions) {
		const { params, pathParams, body } = options;

		const httpParams = params as HttpParams;

		if (!httpParams)
			return throwError(
				() =>
					new ApplicationError(
						"No params provided",
						this.constructor.name,
						this.editScenarioLayer.name
					)
			);

		const tenantId = httpParams.get("tenantId");

		if (!tenantId)
			return throwError(
				() =>
					new ApplicationError(
						"No tenant token provided",
						this.constructor.name,
						this.editScenarioLayer.name
					)
			);

		const appId = pathParams?.["appId"];
		const scenarioId = pathParams?.["scenarioId"];
		const layerId = pathParams?.["layerId"];

		if (!appId || !scenarioId || !layerId)
			return throwError(
				() =>
					new ApplicationError(
						"Missing required parameters",
						this.constructor.name,
						this.editScenarioLayer.name
					)
			);

		if (!body)
			return throwError(
				() =>
					new ApplicationError(
						"No body provided",
						this.constructor.name,
						this.editScenarioLayer.name
					)
			);

		return of(EDIT_SCENARIO_LAYER_RESPONSE);
	}
}
